import { useState } from "react";
import Modal from "../shared/Modal";
import { useSelector } from "react-redux";

import { selectUser } from "../../redux/features/appData/";

import "./ModalSlackProcessing.css";
import { apiSyncWorkspace } from "../../api";

import toast from "react-hot-toast";
import { toastFail, toastSuccess } from "../../config";

export const enum SyncResult {
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
  TOKEN_REVOKED = "TOKEN_REVOKED",
  ALREADY_PROCESSING = "ALREADY_PROCESSING",
}

type ModalSlackProcessingProps = {
  isOpen: boolean;
  onClose: any;
};

type ProcessingState = "ready" | "processing" | "done" | "error";

export const ModalSlackProcessing = ({
  isOpen = false,
  onClose,
}: ModalSlackProcessingProps) => {
  const storeUser = useSelector(selectUser);

  const [processingState, setProcessingState] =
    useState<ProcessingState>("ready");
  const [howManyDays, setHowManyDays] = useState<number>(7);

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = async () => {
    if (!storeUser) {
      return;
    }

    setProcessingState("processing");
    const result = await apiSyncWorkspace(
      storeUser.currentWorkspaceId,
      howManyDays
    );
    console.log("sync result", result);
    if (result === SyncResult.FAILURE) {
      toast("Error syncing workspace", toastFail);
      setProcessingState("error");
    }

    if (result === SyncResult.SUCCESS) {
      toast("Workspace synced", toastSuccess);
      setProcessingState("done");
    }

    if (result === SyncResult.ALREADY_PROCESSING) {
      toast("Workspace already syncing", toastFail);
      setProcessingState("processing");
    }

    if (result === SyncResult.TOKEN_REVOKED) {
      toast("Workspace token revoked", toastFail);
      setProcessingState("error");
    }

    onClose();
  };

  let processingColor = "";
  switch (processingState) {
    case "ready":
      processingColor = "blue";
      break;
    case "processing":
      processingColor = "orange";
      break;
    case "done":
      processingColor = "green";
      break;
    case "error":
      processingColor = "red";
      break;
  }

  return (
    <>
      <Modal isOpen={isOpen} style={null} onClose={handleClose}>
        <div className="modal-slack-processing-container">
          <div className="modal-slack-processing-title">
            <h2>Connect Slack and Find Your Links</h2>
          </div>

          <div className="modal-slack-processing-body">
            Connect to Slack and we'll find all the links your team has dropped
            into Slack.
            <ul>
              <li>
                We'll find everything you dropped and save it to Your Links
              </li>
              <li>
                We'll find any messages with links that you were mentioned in to
                make sure you don't miss anything
              </li>
              <li>We'll let you know when we're done</li>
            </ul>
          </div>

          <div className="modal-slack-processing-days">
            Previous days to process:
            <input
              type="text"
              value={howManyDays === 0 ? "" : howManyDays}
              onChange={(e: any) => {
                // if (isNaN(e.target.value)) {
                //   setHowManyDays(7);
                //   e.preventDefault();
                //   return;
                // }

                let days = Number(e.target.value);
                if (days > 90) {
                  days = 90;
                }
                setHowManyDays(days);
              }}
            />
          </div>

          <div className="modal-slack-processing-status">
            Status:{" "}
            <span style={{ color: processingColor }}>{processingState}</span>
          </div>

          <div className="modal-slack-processing-buttons">
            <button
              className="modal-slack-processing-buttons-cancel"
              onClick={handleClose}>
              Cancel
            </button>
            <button
              className="modal-slack-processing-buttons-cancel"
              onClick={() => onClose()}>
              Force Refresh
            </button>
            <button
              onClick={handleSubmit}
              className="modal-slack-processing-buttons-delete"
              disabled={howManyDays < 1 || processingState === "processing"}>
              {processingState === "processing"
                ? "In Progress"
                : "Start Processing"}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};
